var _dec, _dec2, _class, _class2;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { useCurrencyStore, useFacetsStore, useSearchStore, useSearchWizardStore } from '#imports';
import { Component, Vue, Watch } from 'vue-property-decorator';
import ErrorCapture from '~/mixins/ErrorCaptured';
import DefaultTemplate from './default.vue';
var HomepageLayout = (_dec = Component({
  components: {
    DefaultTemplate
  },
  mixins: [ErrorCapture],
  setup() {
    var searchStore = useSearchStore(usePinia());
    var searchWizardStore = useSearchWizardStore(usePinia());
    searchWizardStore.isSearchWizardOpen = false;
    var facetsStore = useFacetsStore();
    // setup to fetch currencies ASAP
    var currencyStore = useCurrencyStore();
    return {
      currencyStore,
      facetsStore,
      searchWizardStore,
      searchStore
    };
  }
}), _dec2 = Watch('searchWizardStore.isSearchWizardOpen'), _dec(_class = (_class2 = class HomepageLayout extends Vue {
  searchIsOpen() {
    if (process.client && !this.searchWizardStore.isSearchWizardOpen) {
      var _document$getElementB;
      (_document$getElementB = document.getElementById('__nuxt')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.classList.remove('homepage-search-open', 'active-tab-search');
    }
  }
  mounted() {
    this.$nextTick(() => {
      var _document$getElementB2;
      this.searchIsOpen();
      if ((_document$getElementB2 = document.getElementById('__nuxt')) !== null && _document$getElementB2 !== void 0 && _document$getElementB2.classList.contains('homepage-search-open')) {
        var _document$getElementB3;
        (_document$getElementB3 = document.getElementById('autosuggest__input')) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.focus();
      }
    });
  }
}, (_applyDecoratedDescriptor(_class2.prototype, "searchIsOpen", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "searchIsOpen"), _class2.prototype)), _class2)) || _class);
export { HomepageLayout as default };